/**
 * Volume Discount Selector
 * Handles radio button selection and updates the hidden quantity input
 */
class VolumeDiscountSelector extends HTMLElement {
  constructor() {
    super();
    this.radioButtons = this.querySelectorAll('.volume-discount-radio');
    this.quantityInput = this.querySelector('.volume-discount-quantity-input');
    this.options = this.querySelectorAll('.volume-discount-option');
    
    // Get form ID to find the form
    const formId = this.dataset.formId;
    this.form = formId ? document.getElementById(formId) : this.closest('form');
    
    if (!this.quantityInput) {
      console.warn('Volume discount selector: quantity input not found');
      return;
    }
    
    // Also find the hidden quantity input from quantity-input component if it exists
    if (this.form) {
      const hiddenQuantityInput = this.form.querySelector('quantity-input input[name="quantity"]');
      if (hiddenQuantityInput) {
        // Hide the original quantity input
        hiddenQuantityInput.closest('quantity-input')?.setAttribute('style', 'display: none;');
      }
    }
    
    // Add event listeners to radio buttons
    this.radioButtons.forEach(radio => {
      radio.addEventListener('change', this.handleChange.bind(this));
    });
    
    // Initialize with the checked option
    const checkedRadio = this.querySelector('.volume-discount-radio:checked');
    if (checkedRadio) {
      this.updateQuantity(checkedRadio.value);
      this.updateSelectedState(checkedRadio);
    }
  }
  
  /**
   * Handles radio button change event
   * @param {Event} event - Change event
   */
  handleChange(event) {
    const radio = event.target;
    this.updateQuantity(radio.value);
    this.updateSelectedState(radio);
  }
  
  /**
   * Updates the hidden quantity input value
   * @param {string} quantity - The quantity value
   */
  updateQuantity(quantity) {
    if (this.quantityInput) {
      this.quantityInput.value = quantity;
      
      // Also update the hidden quantity input from quantity-input component if it exists
      if (this.form) {
        const hiddenQuantityInput = this.form.querySelector('quantity-input input[name="quantity"]');
        if (hiddenQuantityInput) {
          hiddenQuantityInput.value = quantity;
        }
      }
      
      // Dispatch change event to notify other components
      const changeEvent = new Event('change', { bubbles: true });
      this.quantityInput.dispatchEvent(changeEvent);
    }
  }
  
  /**
   * Updates the visual selected state of options
   * @param {HTMLElement} selectedRadio - The selected radio button
   */
  updateSelectedState(selectedRadio) {
    // Remove selected class from all options
    this.options.forEach(option => {
      option.classList.remove('volume-discount-option--selected');
    });
    
    // Add selected class to the selected option
    const selectedOption = selectedRadio.closest('.volume-discount-option');
    if (selectedOption) {
      selectedOption.classList.add('volume-discount-option--selected');
    }
  }
}

customElements.define('volume-discount-selector', VolumeDiscountSelector);

// Also handle if the selector is already in the DOM (for dynamic content)
document.addEventListener('DOMContentLoaded', () => {
  const selectors = document.querySelectorAll('.volume-discount-selector');
  selectors.forEach(selector => {
    if (!selector.closest('volume-discount-selector')) {
      // Wrap in custom element if not already wrapped
      const wrapper = document.createElement('volume-discount-selector');
      selector.parentNode.insertBefore(wrapper, selector);
      wrapper.appendChild(selector);
    }
  });
});

